import React, { useState } from 'react';
import './AddWorkspaceModal.css';

function AddWorkspaceModal({ isOpen, onClose, onSubmit }) {
  const [workspaceUrl, setWorkspaceUrl] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!workspaceUrl.trim()) {
      setError('Please enter a workspace URL');
      return;
    }

    // Clean the input - remove .slack.com if user added it
    let cleanUrl = workspaceUrl.trim().toLowerCase();
    cleanUrl = cleanUrl.replace(/^https?:\/\//, ''); // Remove protocol
    cleanUrl = cleanUrl.replace(/\.slack\.com.*$/, ''); // Remove .slack.com and anything after
    cleanUrl = cleanUrl.replace(/[^a-z0-9-]/g, ''); // Only allow alphanumeric and hyphens

    if (!cleanUrl) {
      setError('Invalid workspace URL');
      return;
    }

    onSubmit(cleanUrl);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>

        <div className="modal-header">
          <h2>Sign in to another workspace</h2>
          <p className="modal-subtitle">Enter your workspace's Slack URL</p>
        </div>

        <form onSubmit={handleSubmit} className="workspace-form">
          <div className="input-group">
            <div className="input-wrapper">
              <input
                type="text"
                value={workspaceUrl}
                onChange={(e) => setWorkspaceUrl(e.target.value)}
                placeholder="your-workspace"
                autoFocus
                className="workspace-input"
              />
              <span className="domain-suffix">.slack.com</span>
            </div>
            {error && <span className="error-message">{error}</span>}
          </div>

          <button type="submit" className="submit-button">
            Continue
          </button>

          <div className="help-text">
            <p>Don't know your workspace URL?</p>
            <a
              href="https://slack.com/get-started#/find"
              target="_blank"
              rel="noopener noreferrer"
            >
              Find your workspace
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddWorkspaceModal;
